import type { Locale } from "./locales";

export interface LanguageOption {
  code: Locale;
  /** English name, for the accessible label. */
  label: string;
  /** Authored, never machine-translated. */
  nativeName: string;
  /**
   * Shown in place of `nativeName` where the masthead runs out of room — the three native
   * names need 249px of a 390px viewport. Authored alongside `nativeName` and in the same
   * script, never a translation: these never reach the CSVs. The accessible name stays
   * `nativeName` at every width, so this is only ever what the eye reads.
   */
  shortName: string;
}

export const languageOptions: LanguageOption[] = [
  { code: "en", label: "English", nativeName: "English", shortName: "EN" },
  { code: "el", label: "Greek", nativeName: "Ελληνικά", shortName: "ΕΛ" },
  { code: "ru", label: "Russian", nativeName: "Русский", shortName: "RU" },
];
